import React, { useRef } from 'react';

import CommonImage from '@components/CommonImage';

const TNAAccordian = ({ id = 'One', title = 'Pre Production', expand, children }) => {
	const tnaInfoRef = useRef(null);
	return (
		<React.Fragment>
			<div className="card">
				<div className="card-header" id={`heading${id}`}>
					<h2 className="mb-0">
						<button
							className="btn btn-link btn-block d-flex justify-content-between text-left gray_dark_01 regular-14 weight-600"
							type="button"
							data-toggle="collapse"
							data-target={`#collapse${id}`}
							aria-expanded={expand}
							aria-controls={`collapse${id}`}
						>
							<p className="medium-14">{title}</p>
							<div className="arrow-down">
								<CommonImage
									src="/icons/down-arrow-gray-dark-02.svg"
									alt="check"
									width="20px"
									isStatic={true}
								/>
							</div>
						</button>
					</h2>
				</div>
				<div
					id={`collapse${id}`}
					className={`collapse scroll-x-label ${expand ? 'show' : ''}`}
					aria-labelledby={`heading${id}`}
					// data-parent="#accordionExample"
					ref={tnaInfoRef}
				>
					<div className="card-body  m-0 border-0">{children}</div>
				</div>
			</div>
		</React.Fragment>
	);
};
export default TNAAccordian;
